webpackJsonp([38798802261941],{

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookCollections = __webpack_require__(105);
	
	var _LoreHookCollections2 = _interopRequireDefault(_LoreHookCollections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookCollections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-collections'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-collections' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Iterates through all models in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.models'
	      ),
	      ' and creates a corresponding Collection for each of them. This is done so we can fetch collections of resources and not just individual resources.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This hook isn\'t meant to be interacted with directly at the moment. While there are things you ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'could'
	        ),
	        ' do with it, the use cases for needing to do so are not clear.'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Config'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = {\n\n        /**\n         * While this file can influence the behavior of collections, there is currently\n         * no clear reason why you would ever need to use it.\n         *\n         * If you need to define collection specific behavior (such as parsing server responses\n         * or defining headers to add to requests) you should do that in \'config/connections.js\'.\n         *\n         * If you have multiple connections, and need to define which collections use each\n         * connection, you should do that in \'config/models.js\' as this file inherits that\n         * behavior.\n         *\n         */\n\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook generates the collections that are used by the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'find'
	      ),
	      ' action to communicate with the API server and retrieve a list of resources.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, given a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      ' model, and assuming the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'apiRoot'
	      ),
	      ' for the default ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connection'
	      ),
	      ' is set to',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://api.example.com'
	      ),
	      ', the code below will produce an API call to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://api.example.com/tweets?user=1'
	      )
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      var collection = new lore.collections.tweet();\n\n      collection.fetch({\n        data: {\n          user: 1\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-collections-index-js-a58c8726f2521d2bc31a.js